import { queryOptions, useQuery } from '@tanstack/react-query';

import { ApiResponse, QueryOptions } from '@cast/shared-types';
import { DboAdvisorCacheGroupsResponse } from '@cast/types-database-optimizer';

import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

const apiFn = apiClient.dbo.getPerformanceAdvisorCacheGroups;

type PerformanceAdvisorCacheGroupsQueryData = ApiResponse<typeof apiFn>;

export type PerformanceAdvisorCacheGroupsQueryArgs<SELECT> = QueryOptions<
  PerformanceAdvisorCacheGroupsQueryData,
  SELECT
>;

export const DBO_PERFORMANCE_ADVISOR_CACHE_GROUPS_QUERY_KEY =
  'dbo-performance-advisor-cache-groups';

const getPerformanceAdvisorCacheGroupsQueryOptions = ({
  organizationId,
}: {
  organizationId: string;
}) =>
  queryOptions({
    queryKey: [DBO_PERFORMANCE_ADVISOR_CACHE_GROUPS_QUERY_KEY] as const,
    queryFn: async () => {
      const { data } = await apiFn({
        organizationId,
        pageLimit: '1000',
      });
      return data;
    },
  });

export const usePerformanceAdvisorCacheGroupsQuery = <
  SELECT = DboAdvisorCacheGroupsResponse
>({
  enabled,
  select,
  refetchInterval,
}: PerformanceAdvisorCacheGroupsQueryArgs<SELECT> = {}) => {
  const { currentOrganization } = useOrganizations();

  const options = getPerformanceAdvisorCacheGroupsQueryOptions({
    organizationId: currentOrganization!.id,
  });

  return useQuery({
    ...options,
    enabled,
    select,
    refetchInterval,
  });
};
